module.exports = __webpack_public_path__ + "img/no_filter_outlined_24.ac08365c.svg";